import {connect} from 'react-redux';

import withOverlayControls from 'eventbrite_design_system/structure/hoc/withOverlayControls';

import MadLibs from '../components/MadLibs';

import {getUserCurrentLocation as getUserCurrentLocationAction} from '../redux/location/actions';
import {searchMadLibsFilter} from '../redux/search/actions';

const _mapStateToProps = ({app, location}) => ({
    locationDenied: location.locationDenied,
    isMobile: app.isMobile,
    shouldShowSearchAnimation: app.featureFlags.launchMadlibsSearchAnimation,
});

const _mapDispatchToProps = {
    handleUseCurrentLocation: getUserCurrentLocationAction,
    handleMadLibsSearch: searchMadLibsFilter,
};

export default withOverlayControls(connect(
    _mapStateToProps,
    _mapDispatchToProps
)(MadLibs));
